'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';
import { initialFilterState } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter.consts';
import { useSearchFilter } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-search-filters.hook';
import {
  SearchModalityAnalyticsMap,
  SearchSortAnalyticsMap,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-sort.type';
import { getActiveFilters } from '@/app/(main)/(pages)/busca/[slug]/_utils/active-filters.util';
import { getClearableFilters } from '@/app/(main)/(pages)/busca/[slug]/_utils/filter-availability.util';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { SearchType } from '@/types/most-search-type';
import useDeviceType from '@/hooks/use-device-type.hook';

interface ClearAllFiltersProps {
  modality: SearchType;
  className?: string;
}

export function ClearAllFilters({ modality, className }: ClearAllFiltersProps) {
  const { filters, setFilters } = useSearchFilter();
  const analytics = getAnalyticsPlugin();
  const deviceType = useDeviceType();

  const activeFilters = getActiveFilters(filters, modality);
  const hasCustomSort = filters.orderBy !== initialFilterState.orderBy;

  if (activeFilters.length === 0 && !hasCustomSort) {
    return null;
  }

  const handleClearAll = (): void => {
    setFilters(getClearableFilters(modality));
    analytics.track(AnalyticsEnum.FILTERS_CLEARED_ALL, {
      filtros_ativos: activeFilters,
      tipo_ordenacao: SearchSortAnalyticsMap[filters.orderBy],
      modalidade: SearchModalityAnalyticsMap[modality],
      device_type: deviceType,
    });
  };

  return (
    <Button
      variant="text"
      color="primary"
      className={cn('w-auto px-2 py-1.5 text-sm leading-5', className)}
      onClick={handleClearAll}
      data-testid={DataTestIdEnum.SEARCH_FILTERS_CLEAR_ALL}
    >
      Limpar tudo
    </Button>
  );
}
